import { useCallback } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { ActiveSessionsResponse } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

import { getActiveSessionsKey } from './constants';

const emptyArray: [] = [];

export const useGetActiveSessions = (
  options?: IUseQueryOptionsExtended<ActiveSessionsResponse | undefined, GenericFailure | Error>
) => {
  const { mutate, refetch, ...res } = useEitherQuery(
    getActiveSessionsKey,
    () => services2.userSessionsService.getActiveSessions(),
    {
      placeholderData: keepPreviousData,
      staleTime: 5 * 60 * 1000,
      ...options,
    }
  );

  const mutateAfterLogOut = useCallback(
    (id: number) => {
      mutate((prevResponse) => {
        if (prevResponse === undefined) {
          refetch();
          return;
        }

        const newResponse = new ActiveSessionsResponse();
        newResponse.sessions = prevResponse.sessions.filter((s) => s.id !== id);

        return newResponse;
      });
    },
    [mutate, refetch]
  );

  return {
    ...res,
    sessions: res.data?.sessions || emptyArray,
    total: res.data?.sessions?.length ?? 0,
    keys: getActiveSessionsKey,
    refetch,
    mutateAfterLogOut,
  };
};
